import React, { useState } from "react";
import { UseEquipoModeloOperadorTable } from "./UseEquipoModeloOperadorTable";
import { CabeceraTable } from "../../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../../components/Table/TableBaseComponent";
import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import IconHelper from "../../../../../utils/helpers/iconHelper";
import { useBoolean } from "@fluentui/react-hooks";
import { IEquipoModeloOperadorDTO } from "../../../../../Interfaces/auxiliar/IOperador";
import themeBase from "../../../../../utils/theme/themeBase";
import { PanelNuevoEquipoModeloOperador } from "../nuevoEquipoModeloOperador/PanelNuevoEquipoModeloOperador";
import { PanelEliminarEquipoModeloOperador } from "../eliminiarEquipoModeloOperador/PanelEliminarEquipoModeloOperador";

export const EquipoModeloOperadorTable = () => {
  const useTable = UseEquipoModeloOperadorTable();
  const [isOpenNuevo, { setTrue: openPanelNuevo, setFalse: closePanelNuevo }] =
    useBoolean(false);
   const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);

   const [item, setItem] = useState<IEquipoModeloOperadorDTO>({
          equipoModeloId: "",
          operadorId:"",
          equipoModelo: "",
          tipoEquipo: "",
          nombrePersona:""
          
      })

  const buttonLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD_TABLE,
      text: "Nuevo",
      onClick: openPanelNuevo,
    },
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: () => {
        useTable.handleResetUpdate();
      },
    },
  ];
  const _columns = [
    {
      key: "equipoModelo",
      name: "Equipo Modelo",
      fieldName: "equipoModelo",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "tipoEquipo",
      name: "Tipo de Equipo",
      fieldName: "tipoEquipo",
      minWidth: 100,
      maxWidth: 300,
    },
    {
        key: "nombrePersona",
        name: "Operador",
        fieldName: "nombrePersona",
        minWidth: 100,
        maxWidth: 300,
      },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 100,
      maxWidth: 300,
      onRender: (item: IEquipoModeloOperadorDTO) => renderOpciones(item),
    },
  ];
  function renderOpciones(item: IEquipoModeloOperadorDTO) {
    return (
        <>
          <TooltipHost content={"Eliminar"}>
             <Icon
               iconName="Delete"
               className={themeBase.classNamesIcon.iconFont}
               style={{ cursor: "pointer", color: "#0078d3" }}
               onClick={() => {
                 setItem(item)
                 openPanelEliminar()
               }}
             />
           </TooltipHost>
         
        </>
      );
}
  return (
    <>
      <CabeceraTable
        Titulo={"Elementos Estandar"}
        SubTitulo={"Gestión de Elementos Estandar"}
        onKeyUp={useTable._onkeyUpSearchTable}
      />
      <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={useTable.items}
        column={_columns}
        isLoading={useTable.loading}
        getPageSize={useTable.onChangeTake}
        pagination={useTable.pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
      />
      <PanelNuevoEquipoModeloOperador reload={useTable.handleResetUpdate} isOpen={isOpenNuevo} onDismiss={closePanelNuevo}/>
      <PanelEliminarEquipoModeloOperador item={item}
       reload={useTable.handleResetUpdate} isOpen={isOpenEliminar} onDismiss={closePanelEliminar}/>
    </>
  );
};
